import React, { useState } from "react";
import styles from "./RezyListLoopTxt.module.css";

const RezylistLoopTxt = () => {
  const contents = [
    "90% Chances of rooms getting available in next 18 hours",
    "Join 3 Guests Who Got Notified and Booked in the Last 2 Hours!",
    "Be the Next One! 3 Guests Secured Their Room – Will You?",
    "Stay Ahead! Get Notified! And Book Your Dream Room",
    "4 Rooms Opened Up in 7 Hours – Be the Next to Book",
  ];

  const [randomIndex] = useState(() =>
    Math.floor(Math.random() * contents.length)
  );

  return <p className={styles.loopTxt}>{contents[randomIndex]}</p>;
};

export default RezylistLoopTxt;
